@if(route){
	<button
		[routerLink]="route"
		routerLinkActive="text-peps-gold"
		[routerLinkActiveOptions]="{ exact: true }"
		class="text-peps-dark-200 py-4 cursor-pointer hover:text-peps-gold transition-colors duration-300 text-nowrap uppercase"
	>{{ text }}</button>
} @else {
	<button
		class="text-peps-dark-200 py-4 cursor-pointer hover:text-peps-gold transition-colors duration-300 text-nowrap uppercase"
	>{{ text }}</button>
}
